// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"62":"54044bc8","943":"042bfbda"}[chunkId] + ".css";
};